module.exports = __webpack_public_path__ + "media/images/boxes/seo-box500-fa562cd27ab258769dc2aa397c8425b1.png";